export default __webpack_public_path__ + "static/media/jva.2977d951.jpg";